{
  "familyId": "TOPO-NL-EILANDEN",
  "questions": [
    {
      "id": "TOPO-NL-EILANDEN-001",
      "familyId": "TOPO-NL-EILANDEN",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_eilanden",
      "questionType": "multiple_choice",
      "question": "Hoeveel bewoonde Waddeneilanden heeft Nederland?",
      "options": [
        "5",
        "3",
        "7",
        "4"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_eilanden"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Waddeneilanden",
            "content": "Nederland heeft 5 bewoonde Waddeneilanden. Van west naar oost: Texel, Vlieland, Terschelling, Ameland, Schiermonnikoog. Onthoud: 'Texel Vindt Terschelling Altijd Saai' (eerste letters).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "eilanden_aantal",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Nederland heeft 5 bewoonde Waddeneilanden: Texel, Vlieland, Terschelling, Ameland en Schiermonnikoog. Ze liggen in de Waddenzee, boven Noord-Holland, Friesland en Groningen.",
        "solutionSteps": [
          "5 bewoonde Waddeneilanden",
          "Van west naar oost: Texel, Vlieland, Terschelling, Ameland, Schiermonnikoog",
          "Ezelsbruggetje: TVTAS (eerste letters)"
        ],
        "distractorExplanations": {
          "0": "Goed! Nederland heeft 5 bewoonde Waddeneilanden.",
          "1": "3 is te weinig. Er zijn 5 bewoonde eilanden, niet 3.",
          "2": "7 klopt niet. Er zijn 5 bewoonde eilanden. Er zijn wel onbewoonde zandplaten (zoals Rottumerplaat).",
          "3": "4 is te weinig. Vergeet je Schiermonnikoog of Vlieland niet?"
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-001-OPT1",
            "optionIndex": 1,
            "label": "3 is te weinig"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-001-OPT2",
            "optionIndex": 2,
            "label": "7 klopt niet"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-001-OPT3",
            "optionIndex": 3,
            "label": "4 is te weinig"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-EILANDEN-002",
      "familyId": "TOPO-NL-EILANDEN",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_eilanden",
      "questionType": "multiple_choice",
      "question": "Welk Waddeneiland is het grootst?",
      "options": [
        "Texel",
        "Terschelling",
        "Ameland",
        "Schiermonnikoog"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_eilanden"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Texel",
            "content": "Texel is het grootste en westelijkste Waddeneiland. Het ligt boven Noord-Holland en heeft de meeste inwoners (~13.500). Texel is ook het enige eiland dat je met een gewone veerboot bereikt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "eilanden_texel",
      "variantIndex": 2,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Texel is het grootste Waddeneiland (~160 km²). Het ligt het meest westelijk, boven Noord-Holland. Terschelling is het op één na grootst.",
        "solutionSteps": [
          "Texel = grootste Waddeneiland (~160 km²)",
          "Ligt boven Noord-Holland",
          "Meeste inwoners (~13.500)"
        ],
        "distractorExplanations": {
          "0": "Goed! Texel is het grootste Waddeneiland.",
          "1": "Terschelling is het op één na grootst, maar Texel is groter.",
          "2": "Ameland is kleiner dan Texel en Terschelling.",
          "3": "Schiermonnikoog is het kleinste bewoonde Waddeneiland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Terschelling"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-002-OPT2",
            "optionIndex": 2,
            "label": "Ameland is kleiner dan Texel en Terschelling"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-002-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Schiermonnikoog"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-EILANDEN-003",
      "familyId": "TOPO-NL-EILANDEN",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_eilanden",
      "questionType": "multiple_choice",
      "question": "Welk Waddeneiland ligt het meest oostelijk?",
      "options": [
        "Schiermonnikoog",
        "Texel",
        "Ameland",
        "Vlieland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_eilanden"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde Waddeneilanden",
            "content": "Van west naar oost: Texel → Vlieland → Terschelling → Ameland → Schiermonnikoog. Schiermonnikoog ligt het meest oostelijk, boven Groningen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "eilanden_volgorde",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Schiermonnikoog ligt het meest oostelijk, boven de provincie Groningen. De volgorde van west naar oost: Texel, Vlieland, Terschelling, Ameland, Schiermonnikoog.",
        "solutionSteps": [
          "Volgorde west → oost: T-V-T-A-S",
          "Schiermonnikoog = meest oostelijk",
          "Ligt boven Groningen"
        ],
        "distractorExplanations": {
          "0": "Goed! Schiermonnikoog ligt het meest oostelijk.",
          "1": "Texel ligt het meest westelijk, niet oostelijk.",
          "2": "Ameland ligt op de vierde plek van west naar oost, niet het meest oostelijk.",
          "3": "Vlieland ligt op de tweede plek, tussen Texel en Terschelling."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-003-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Texel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-003-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Ameland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-003-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Vlieland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-EILANDEN-004",
      "familyId": "TOPO-NL-EILANDEN",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_eilanden",
      "questionType": "multiple_choice",
      "question": "In welke zee liggen de Waddeneilanden?",
      "options": [
        "De Waddenzee",
        "De Noordzee",
        "Het IJsselmeer",
        "De Zuiderzee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_eilanden"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Waddenzee",
            "content": "De Waddeneilanden liggen in de Waddenzee, tussen de eilanden en het vasteland. De Noordzee ligt aan de andere kant (noordkant) van de eilanden. De Waddenzee is UNESCO Werelderfgoed.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "eilanden_waddenzee",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De Waddeneilanden liggen in de Waddenzee. De Waddenzee is de ondiepe zee tussen de eilanden en het vasteland. Aan de noordkant van de eilanden ligt de Noordzee.",
        "solutionSteps": [
          "Waddeneilanden → Waddenzee",
          "Waddenzee = tussen eilanden en vasteland",
          "Noordzee = aan de andere kant (noord)"
        ],
        "distractorExplanations": {
          "0": "Goed! De Waddeneilanden liggen in de Waddenzee.",
          "1": "De Noordzee ligt aan de noordkant van de eilanden. De Waddenzee ligt tussen de eilanden en het vasteland.",
          "2": "Het IJsselmeer ligt ten zuiden van Friesland, niet bij de Waddeneilanden.",
          "3": "De Zuiderzee bestaat niet meer — die is in 1932 afgesloten door de Afsluitdijk en heet nu IJsselmeer."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-004-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Noordzee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-004-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Het IJsselmeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-EILANDEN-004-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Zuiderzee"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-EILANDEN-005",
      "familyId": "TOPO-NL-EILANDEN",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "nederland",
      "subSkill": "topo_eilanden",
      "questionType": "ordering",
      "question": "Zet de Waddeneilanden in volgorde van west naar oost.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Texel",
          "Vlieland",
          "Terschelling",
          "Ameland",
          "Schiermonnikoog"
        ],
        "correctOrder": [
          0,
          1,
          2,
          3,
          4
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_eilanden"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ezelsbruggetje",
            "content": "Van west naar oost: Texel, Vlieland, Terschelling, Ameland, Schiermonnikoog. Onthoud: 'Texel Vindt Terschelling Altijd Saai' (TVTAS).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "eilanden_volgorde_ordering",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Van west naar oost: Texel → Vlieland → Terschelling → Ameland → Schiermonnikoog. Ezelsbruggetje: TVTAS.",
        "solutionSteps": [
          "1. Texel (boven Noord-Holland)",
          "2. Vlieland",
          "3. Terschelling",
          "4. Ameland",
          "5. Schiermonnikoog (boven Groningen)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    }
  ]
}